module.exports = __webpack_public_path__ + "static/media/notification-bg.0151cc9e.png";